// extracted by mini-css-extract-plugin
export default {"fieldset":"TermsAndConditions_fieldset__p97F6","pdfContainer":"TermsAndConditions_pdfContainer__EEO1O"};